import type { RouteMode } from "../../router";
import { isPlatformGamePath } from "../../shared/routing/game-path-mode";
import type { GameApiMode } from "../../shared/services/game-api";

function currentPathname(): string {
  return typeof window === "undefined" ? "" : window.location.pathname;
}

export function isAugmentedStoneFlickingV2Path(
  pathname = currentPathname(),
): boolean {
  return isPlatformGamePath("augmented-stone-flicking", pathname);
}

export function resolveAugmentedStoneFlickingRouteMode(
  pathname = currentPathname(),
): RouteMode {
  return isAugmentedStoneFlickingV2Path(pathname) ? "v2" : "legacy";
}

export function resolveAugmentedStoneFlickingGameApiMode(
  pathname = currentPathname(),
): GameApiMode {
  return isAugmentedStoneFlickingV2Path(pathname) ? "game-platform" : "legacy";
}
